import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const HEADER_OFFSET_PX = 96;
const MAX_SCROLL_WAIT_MS = 2500;

function smoothScrollToElement(el: HTMLElement) {
  const y = el.getBoundingClientRect().top + window.scrollY - HEADER_OFFSET_PX;
  window.scrollTo({ top: Math.max(y, 0), behavior: "smooth" });
}

export const useScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // Hash navigation (e.g. /#about)
    if (hash) {
      const id = hash.replace("#", "");
      let cancelled = false;
      const startedAt = performance.now();

      const tryScroll = () => {
        if (cancelled) return;

        const el = document.getElementById(id);
        if (el) {
          smoothScrollToElement(el);
          return;
        }

        if (performance.now() - startedAt < MAX_SCROLL_WAIT_MS) {
          requestAnimationFrame(tryScroll);
        }
      };

      requestAnimationFrame(tryScroll);
      return () => {
        cancelled = true;
      };
    }

    // Regular navigation
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [pathname, hash]);
};

export const ScrollToTop = () => {
  useScrollToTop();
  return null;
};

